// src/js/reducers/index.js
import * as types from "../constants/action-types";

export default function postcodeReducer(state = [], action) {
    switch (action.type) {
       
        case types.LOGOUT:
            return []
        case types.LOAD_POSTCODES_SUCCESS:
            return action.postcodes;
        
        default:
            return state;
    };
};

